import Box from "@mui/material/Box";
import { FS } from "@plannel/utils/font-util";

/*
  "라벨 — [컨트롤]" 한 줄. 설정 패널의 행 하나를 표현한다.

  라벨은 왼쪽 정렬 고정폭 거터다. 고정폭이라 컨트롤 시작선이 행마다 어긋나지 않고,
  왼쪽 정렬이라 짧은 라벨 앞에 빈칸이 생기지 않는다(minWidth 로 두면 행마다 폭이 달라진다).

  폭 216 은 영어 최장 라벨 기준 — "Initial Values for Demand Plan"(30자, 12px 에서 약 180px).
  vi 는 훨씬 길어서(shipmentTime = "Thời gian xuất hàng theo tiêu chuẩn thùng nhập kho", 50자)
  몇 개는 두 줄로 접힌다. vi 최장(약 315px)에 맞추면 영어에서 거터 절반이 빈칸이 되므로
  접히는 쪽을 택했다.

  컨트롤은 자기 라벨을 갖지 않는 게 기본이다 — 거터가 이미 이름을 말한다.
  단위나 구성원 이름처럼 거터가 못 하는 말이 있을 때만 컨트롤이 라벨을 단다
  (예: "Actual Sales Period" 거터 + "Month" 입력칸, "Plan Horizon" 거터 + "Start"/"End").
*/
export const PANEL_LABEL_SX = {
  flexShrink: 0,
  alignSelf: "center",
  width: 216,
  pr: 2,
  textAlign: "left",
  fontSize: FS.SUB,
  color: "text.secondary",
};

/*
  패널 폼 컨테이너에 얹는다.
  체크박스/라디오 라벨은 MUI 기본이 16px 인데, 그대로 두면 이 패널에서 제일 큰 글자가 되어
  섹션 제목(14px)과 거터(12px)를 눌러버린다. 값과 같은 14px(body2)로 낮춘다.
*/
export const PANEL_FORM_SX = {
  "& .MuiFormControlLabel-label": { fontSize: FS.H2 },
};

// pl 은 섹션 제목(SectionTitle)의 들여쓰기와 같은 값이다 — 맞춰야 제목과 행이 한 선에서 시작하고,
// 라벨이 패널 왼쪽 테두리에 붙지 않는다.
export const PANEL_CONTENT_PL = "10px";

/*
  거터 행이 아니라 홀로 서는 체크박스 행에 얹는다.
  MUI FormControlLabel 은 기본 marginLeft: -11px 이고 Checkbox 는 내부 padding: 9px 이라,
  그냥 두면 체크박스 네모의 왼쪽 끝이 -11 + 9 = -2px — 컨테이너를 벗어나 패널 테두리에 붙는다.
  네모 왼쪽 끝 = ml + 9 이므로, 거터 라벨과 같은 10px 에 놓으려면 ml 이 1px 이어야 한다.
*/
export const PANEL_CHECKBOX_SX = {
  ml: "1px",
};

// boxSizing 을 직접 잡는다 — 이 앱은 CssBaseline 을 전역으로 렌더하지 않아서(인증 페이지에만 있다)
// border-box 리셋이 없다. 그냥 두면 width:100% + pl 이 부모를 pl 만큼 넘겨서 가로 스크롤바가 생긴다.
//
// mt 1 = 8px. 컨트롤이 40px 이므로 행 간격은 48px 이 된다. MUI 기본 감각인 16px 은
// 설정 폼처럼 행이 10개 넘게 쌓이는 자리에선 패널을 넘겨 스크롤을 만든다.
export const PanelField = ({ label, children, sx }) => (
  <Box sx={{ display: "flex", alignItems: "center", width: "100%", boxSizing: "border-box", mt: 1, pl: PANEL_CONTENT_PL, ...sx }}>
    <Box sx={PANEL_LABEL_SX}>{label}</Box>
    {children}
  </Box>
);

export default PanelField;
